module.exports = __webpack_public_path__ + "static/media/skny.82e5e9d3.png";